// © Microsoft Corporation. All rights reserved.

import { DesignSystem, accentFillRest, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const avatarSize = "34px";
const sidePadding = "14px";
const minCardWidth = "240px";
const bodyTextColor = "#404040";

export const ContentCardStyles = (config: DesignSystem) =>  ({
    contentCardContainer: {
        display: "flex",
        "flex-direction": "column",
        "min-width": minCardWidth,
        padding: "0 ",
        background: neutralLayerCard,
        color: neutralForegroundRest,
        "border-radius": "6px",
        "-webkit-box-shadow": "0px 0px 1px rgba(0, 0, 0, 0.05), 0px 0px 12px rgba(0, 0, 0, 0.08);",
        "-moz-box-shadow": "0px 0px 1px rgba(0, 0, 0, 0.05), 0px 0px 12px rgba(0, 0, 0, 0.08);",
        "box-shadow": "0px 0px 1px rgba(0, 0, 0, 0.05), 0px 0px 12px rgba(0, 0, 0, 0.08);",

        "& *.no-link:hover": {
            "text-decoration": "none",
            cursor: "default"
        },

        "& .cwt-user-header": {
            display: "flex",
            "align-items": "center",
            padding: "13px 13px 11px",

            "& .cwt-avatar-container": {
                width: avatarSize,
                height: avatarSize,

                "& .cwt-avatar": {
                    "min-width": avatarSize,
                    "max-width": avatarSize,
                    height: avatarSize
                }
            },

            "& .cwt-header-content": {
                margin: "-5px 8px 0",

                "& .cwt-name": {
                    "font-size": "14px",
                    "line-height": "16px",
                    "font-weight": "600",
                    color: accentFillRest
                },

                "& .cwt-datetime": {
                    "font-size": "12px",
                    "font-weight": "normal",
                    color: neutralForegroundHint
                }
            }
        },

        "& .cwt-content-detail": {
            "& .cwt-image-container": {
                "& .cwt-content-image": {
                    width: "100%",
                    "max-width": "100%"
                }
            },

            "& .cwt-content-body": {
                margin: sidePadding,
                "font-size": "12px",
                "font-weight": "normal",
                "line-height": "16px",
                color: neutralForegroundHint,
                "letter-spacing": applyLocalizedProperty("-0.24px", "0", config.direction)
            }
        },

        "& .cwt-social-container": {
            padding: "12px 17px 20px",
            "border-top": "1px solid #949494"
        }
    }
});